var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFamily(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "16px",
    viewBox: "0 0 29 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "37F4AABB-6337-473B-8732-1A2096719956@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WEB-MobileFirstNewLayout_v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile1_Dashboard",
    transform: "translate(-190.000000, -1339.000000)",
    fill: "#353535",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(24.000000, 1309.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(166.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(18.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.38910156,7.11089844 C8.79005273,6.51187109 8.0770293,6.06841211 7.29908008,5.79996484 C8.13228711,5.2260957 8.6796875,4.26567969 8.6796875,3.1796875 C8.6796875,1.42641211 7.25327539,0 5.5,0 C3.74672461,0 2.3203125,1.42641211 2.3203125,3.1796875 C2.3203125,4.26567969 2.86771289,5.2260957 3.70094141,5.79996484 C2.92299219,6.06841211 2.20996875,6.51187109 1.61091992,7.11089844 C0.572107422,8.14973242 0,9.53089844 0,11 L0.859375,11 C0.859375,8.44114648 2.94114648,6.359375 5.5,6.359375 C8.05885352,6.359375 10.140625,8.44114648 10.140625,11 L11,11 C11,9.53089844 10.4278926,8.14973242 9.38910156,7.11089844 Z M5.5,5.5 C4.22058398,5.5 3.1796875,4.459125 3.1796875,3.1796875 C3.1796875,1.90025 4.22058398,0.859375 5.5,0.859375 C6.77941602,0.859375 7.8203125,1.90025 7.8203125,3.1796875 C7.8203125,4.459125 6.77941602,5.5 5.5,5.5 Z",
    fill: "currentColor",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "user"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.656875,10.343125 C12.7855313,9.4718125 11.7484062,8.82678125 10.6168437,8.4363125 C11.8287813,7.60159375 12.625,6.204625 12.625,4.625 C12.625,2.07478125 10.5502188,0 8,0 C5.44978125,0 3.375,2.07478125 3.375,4.625 C3.375,6.204625 4.17121875,7.60159375 5.3831875,8.4363125 C4.251625,8.82678125 3.2145,9.4718125 2.34315625,10.343125 C0.83215625,11.8541563 0,13.863125 0,16 L1.25,16 C1.25,12.2780312 4.27803125,9.25 8,9.25 C11.7219688,9.25 14.75,12.2780312 14.75,16 L16,16 C16,13.863125 15.1678437,11.8541563 13.656875,10.343125 Z M8,8 C6.13903125,8 4.625,6.486 4.625,4.625 C4.625,2.764 6.13903125,1.25 8,1.25 C9.86096875,1.25 11.375,2.764 11.375,4.625 C11.375,6.486 9.86096875,8 8,8 Z",
    fill: "currentColor",
    id: "Shape"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFamily);
export default __webpack_public_path__ + "static/media/icon_family.934a51cd9968343141c1c3152f8fc7bc.svg";
export { ForwardRef as ReactComponent };